module.exports = __webpack_public_path__ + "img/icon-home-re-03.e167bac3.jpg";